module.exports = __webpack_public_path__ + "static/media/subscription-success-icon.80e5902b.webp";